import { env } from './tools';

export const API_URL = env('API_URL');

export const NAME = env('NAME', 'Displayer');

export const DEFAULT_IMAGE_URL = env('DEFAULT_IMAGE_URL');

export const ANIMATIONS = 'fade-in|fade-out|zoom-out|roll-in|blur-out';